/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptAnalyticsBatchResponse {
    getFixupPrototypeFunction() { return PromptAnalyticsBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<PromptAnalyticsBatchResponse>): PromptAnalyticsBatchResponse {
        let obj = Object.assign(new PromptAnalyticsBatchResponse(), model);
        PromptAnalyticsBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptAnalyticsBatchResponse>): PromptAnalyticsBatchResponse {
        if (!model) return null;
        return PromptAnalyticsBatchResponse.newInstance(<PromptAnalyticsBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptAnalyticsBatchResponse) {
        if (!obj) return;

        models.PromptAnalyticsBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptAnalyticsBatchResponse): boolean {
        Object.setPrototypeOf(obj, PromptAnalyticsBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AIGovernancePromptAnalyticsDataResponse.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AIGovernancePromptAnalyticsDataResponse; };

}
